import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs md:text-sm font-bold uppercase tracking-[0.25em] ${className}`}>{children}</p>
);

const VARIANTS = {
  red: "bg-brand-red text-cream hover:bg-brand-reddeep",
  gold: "bg-brand-gold text-ink hover:bg-[#f2bd1d]",
  ink: "bg-ink text-cream hover:bg-black",
  cream: "bg-cream text-ink hover:bg-white",
};

export const Btn = ({ to, href, external = false, variant = "red", className = "", testid, children, onClick, type = "button", disabled }) => {
  const cls = [
    "inline-flex items-center justify-center gap-2 border-[3px] border-ink px-6 py-3.5 font-display uppercase tracking-wide text-lg leading-none",
    "shadow-[6px_6px_0_#111] transition-[transform,box-shadow,background-color] duration-200",
    "hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0_#111]",
    "active:translate-x-[6px] active:translate-y-[6px] active:shadow-none",
    disabled ? "opacity-60 pointer-events-none" : "",
    VARIANTS[variant],
    className,
  ].join(" ");
  if (to) {
    return <Link to={to} data-testid={testid} className={cls} onClick={onClick}>{children}</Link>;
  }
  if (href) {
    const ext = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return <a href={href} data-testid={testid} className={cls} onClick={onClick} {...ext}>{children}</a>;
  }
  return <button type={type} onClick={onClick} data-testid={testid} disabled={disabled} className={cls}>{children}</button>;
};
